import { lazy } from 'react';
import { RouteConfig } from 'react-router-config';

export const productRoutes = (): RouteConfig[] => [
  {
    path: '/workbench/apps',
    exact: true,
    name: '我的产品',
    component: lazy(() => import('@/presentation/pages/product/apps')),
    hideInMenu: true,
    whitelisted: true,
  },
];

export default productRoutes;
